// extracted by mini-css-extract-plugin
export default {"detailContainer":"Detail_detailContainer__JdANd","spinnerContainer":"Detail_spinnerContainer__+2x4j"};